import React from 'react';
import { A } from '@hugendubel/react-basic';
import { TRACK_ID } from '@hugendubel/tracking_client';
import { __ } from 'first-intl';
import { ExternalRoutes } from '../appRoutes';
import { Store } from '../../store';

type HeaderStoreProps = { backLink: string | null };
type HeaderOwnProps = Record<string, unknown>;
export type HeaderProps = HeaderStoreProps & HeaderOwnProps;

export const UnwiredHeader = ({ backLink }: HeaderProps) => {
    const usedBackLink = !backLink || backLink.toLowerCase() === 'none' ? undefined : backLink;

    return (
        <header className="page-head container-fluid hidden-print">
            <div className="row">
                <div className="col-sm-8">
                    <A
                        trackId={TRACK_ID('2019-07-30 06:56:12')}
                        href={usedBackLink || ExternalRoutes.HOME}
                        className="logo"
                        target="_self"
                    >
                        {__(process.env.IS_HUDU ? 'app.hudu.logo' : 'app.eBook.logo')}
                    </A>
                </div>
                <div className="col-sm-4 align-right">
                    {usedBackLink && (
                        <A
                            trackId={TRACK_ID('2019-07-30 06:56:52')}
                            href={usedBackLink}
                            className="btn btn-default back-btn"
                            target="_self"
                        >
                            {__('app.backLink')}
                        </A>
                    )}
                </div>
            </div>
        </header>
    );
};

export const Header = Store.wire<HeaderStoreProps, HeaderOwnProps>(UnwiredHeader, ({ backLink }) => ({ backLink }));
